import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import * as ST from './styled';

const icons = {
    office: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAAH9JREFU' +
        'KBXFk8ENgCAMRcW4gIPoBDi9GziIjqApySO1FA7ERC7lf/p+eyGccbmHzjN2cglrwvN+NLOrMCDVS3FhgGtbE4O2AQVMIyAVXwe8YB' +
        'osYDUBGfZAgTy/gEnnAdDz6cmTMXS1oH6T+2QNNOuKroV8O1lP9LbAkxp++xgPdP02vyQ2MmQAAAAASUVORK5CYII=',
    center: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAAH9JREFU' +
        'KBXFk8ENgCAMRcU4gM4ji+kATuY+jqApySO1FA7ERC7lf/p+eyGs23wPnWfs5BLWhM/jamZXYUCql+LCAHFfEoO2AQVMIyAVXwe8YB' +
        'osYDUBGfZAgTy/gEnnAdDz6cmTMXS1oH6T+2QNNOuKroV8O1lP9LbAkxp++xgPcy83UuV2saYAAAAASUVORK5CYII=',
    dealer: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAAS9JREFU' +
        'KBV9k9FxwkAMRH03fDuUFejEST2ETkhbHheAs28lxTYfaMb4pNOuVgu0j+mxDkTTo9NTr07+LrJ36wuKoUOQZ/CQVfyfq7cuPJmkix' +
        'ZmxfxzsYrnGt3bJAasustGJBMutmYguQmUO/Sq6V21XntS5IF9vn269/z96zcEjt065L0AgAzMxnF62MDz10bgqZKLJzy99kBuTWAi' +
        'sshpKoIFD4ToTftqhcDqsNyvVkYjAICQLPeQXAReKT0IsJrHKeQNNiLy+SaClG1mfYyQS3+t6zoyIsSkYB8bVg7vvq7a9XRgABVYOZ' +
        '4OqxSuB7uNglxpkQBz2NE8v0qm7D01AOkn92FAysLR19ir4Efl6Xo3/hgH6Ul0qMEGOVpzLUpWwcdebl0woZq5dy58xR9WZ4PiQr81' +
        'VgAAAABJRU5ErkJggg==',
    wifi: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAAS9JREFUKB' +
        'V9k9FxwkAMRH03fDuUFejEST2ETkhbHheAs28lxTYfaMb4pNOuVgu0j+mxDkTTo9NTr07+LrJ36wuKoUOQZ/CQVfyfq7cuPJmkixZm' +
        'xfxzsYrnGt3bJAasustGJBMutmYguQmUO/Sq6V21XntS5IF9vn269/z96zcEjt065L0AgAzMxnF62MDz10bgqZKLJzy99kBuTWAiss' +
        'hpKoIFD4ToTftqhcDqsNyvVkYjAICQLPeQXAReKT0IsJrHKeQNNiLy+SaClG1mfYyQS3+t6zoyIsSkYB8bVg7vvq7a9XRgABVYOZ4O' +
        'qxSuB7uNglxpkQBz2NE8v0qm7D01AOkn92FAysLR19ir4Efl6Xo3/hgH6Ul0qMEGOVpzLUpWwcdebl0woZq5dy58xR9WZ4PiQr81Vg' +
        'AAAABJRU5ErkJggg==',
};

export class ContactList extends PureComponent {
    static propTypes = {
        contacts: PropTypes.array,
        onClickContact: PropTypes.func,
    };

    static defaultProps = {
        contacts: [],
        onClickContact: ()=>{},
    };

    state = {
        displayAll: false,
    };

    onChangeDisplayed = () => {
        this.setState(state => ({
            displayAll: !state.displayAll,
        }));
    }

    renderElements(elements, displayAllelem) {
        const { onClickContact } = this.props;

        return elements.slice(0, displayAllelem ? elements.length : 5).map(elem => {
            const { misc, address, hours, id, contactType } = elem;

            return (
                <ST.Elem key={id}>
                    <ST.ElemIconWrap>
                        <ST.ElemIcon src={icons[contactType]}></ST.ElemIcon>
                    </ST.ElemIconWrap>
                    <ST.ElemDescription>
                        <ST.ElemTitle onClick={() => onClickContact(id)}>
                            {misc}
                        </ST.ElemTitle>
                        <ST.ElemAddress>{address}</ST.ElemAddress>
                        <ST.ElemTime>{hours}</ST.ElemTime>
                    </ST.ElemDescription>
                </ST.Elem>
            );
        });
    }

    render() {
        const { contacts } = this.props;
        const { displayAll } = this.state;
        const centers = contacts.filter(item => item.contactType === 'center');
        const offices = contacts.filter(item => item.contactType === 'office');
        const dealers = contacts.filter(item => item.contactType === 'dealer');
        const wifi = contacts.filter(item => item.contactType === 'wifi');

        return (
            <ST.ContactList>
                {offices.length > 0 && <ST.BlockWrap>
                    <ST.BlockTitle>Центры продаж</ST.BlockTitle>
                    <ST.BlockList>
                        {this.renderElements(offices, true)}
                    </ST.BlockList>
                </ST.BlockWrap>}
                {centers.length > 0 && <ST.BlockWrap>
                    <ST.BlockTitle>Сервисные центры</ST.BlockTitle>
                    <ST.BlockList>
                        {this.renderElements(centers, true)}
                    </ST.BlockList>
                </ST.BlockWrap>}
                {dealers.length > 0 && <ST.BlockWrap>
                    <ST.BlockTitle>Адреса наших партнеров</ST.BlockTitle>
                    <ST.BlockList>
                        {this.renderElements(dealers, true)}
                    </ST.BlockList>
                </ST.BlockWrap>}
                {wifi.length > 0 && <ST.BlockWrap>
                    <ST.BlockTitle>Адреса наших партнеров</ST.BlockTitle>
                    <ST.BlockList data-test='list'>
                        {this.renderElements(wifi, displayAll)}
                    </ST.BlockList>
                    <ST.DisplayBtn data-test='btn' onClick={this.onChangeDisplayed}>{displayAll ? 'Скрыть' : 'Показать все адреса'}</ST.DisplayBtn>
                </ST.BlockWrap>}
            </ST.ContactList>
        );
    }
}
